/*
 *
 * Description:
 * This is a context from react, this allows us to share information to child nodes through the application 
 * For more information this is the link for the  react documentation : https://es.reactjs.org/docs/context.html
 * EIF400 -- Paradigmas de Programacion
 * @since II Term - 2021
 * @authors Team 01-10am
 *  - Andres Alvarez Duran 117520958 
 *  - Joaquin Barrientos Monge 117440348
 *  - Oscar Ortiz Chavarria 208260347
 *  - David Zarate Marin 116770797
 *
 */

import { createContext } from "react";


const ThemeContextMsg = createContext(false);

export default ThemeContextMsg;
